<template>
  <b-modal :id="`FormFornecedor`"
           :ref="`FormFornecedor`"
           no-close-on-backdrop
           no-close-on-esc
           class="FormFornecedor"
           header-class="FormFornecedor_header"
           body-class="FormFornecedor_body"
           content-class="FormFornecedor_content"
           size="xl"
           visible
           @hide="hide()">
    <template slot="modal-header">
      <div>
        <b class="ml-2">Beneficiário</b>
      </div>
    </template>
    <div class="row p-2">
      <div class="col-2">
        <label for="cnpj">CNPJ</label>
        <input id="cnpj"
               v-model.lazy="localData.cnpj"
               v-validate:cnpj="{ min: 14 }"
               v-mask="`##.###.###/####-##`"
               type="text"
               name="cnpj"
               class="form-control form-control-sm"
               :class="{'is-invalid': errors.has('cnpj')}"
               @change="getFornecedor()">
        <span class="invalid-feedback">
          {{ errors.first("cnpj") }}
        </span>
      </div>
    </div>
    <div class="row align-items-top p-2">
      <div class="col-5">
        <label for="nome">Nome</label>
        <input id="nome"
               v-model="localData.nome"
               v-validate="'required'"
               type="text"
               name="nome"
               class="form-control form-control-sm"
               :class="{'is-invalid': errors.has('nome')}">
        <span class="invalid-feedback">
          {{ errors.first("nome") }}
        </span>
      </div>
      <div class="col-2">
        <label for="telefone">Telefone</label>
        <input id="telefone"
               v-model.lazy="localData.telefone"
               v-validate:telefone="{ min: 8 }"
               v-mask="'(99) 9999-9999#'"
               name="telefone"
               placeholder="(11) 94891-1518"
               type="text"
               class="form-control form-control-sm"
               :class="{'is-invalid': errors.has('telefone')}">
        <span class="invalid-feedback">
          {{ errors.first("telefone") }}
        </span>
      </div>
      <div class="col-3">
        <label for="email">E-mail</label>
        <input id="email"
               v-model.lazy="localData.email"
               v-validate="'email'"
               type="email"
               name="email"
               class="form-control form-control-sm"
               :class="{'is-invalid': errors.has('email')}">
        <span class="invalid-feedback">
          {{ errors.first("email") }}
        </span>
      </div>
      <div v-if="localData.fornecedor_id"
           class="col-2 d-flex align-items-center">
        <b-form-checkbox
          v-model="localData.ativo"
          switch
          :value="1">
          Ativo
        </b-form-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <BoxEndereco
          :prop-mostrar-exterior="true"
          :no-header="false"
          :data="localData.endereco"
          @onEnderecoAdd="getAddress" />
      </div>
    </div>

    <template slot="modal-footer"
              slot-scope="{ cancel }">
      <button class="btn btn-sm btn-light px-3"
              @click="cancel">
        Voltar
      </button>
      <button class="btn btn-secondary btn-sm"
              @click="propFornecedor ? editarFornecedor() : cadastrarFornecedor()">
        {{ propFornecedor ? 'Editar' : 'Adicionar' }}
      </button>
    </template>
  </b-modal>
</template>

<script>
  // components
  import BoxEndereco from "@/components/SofiaRei/BoxEndereco"

  // services
  import FornecedorService from "@/services/FornecedorService"

  // filters
  import { filterMaskedNumber, firstCapitalize, filterTelefone } from "@/filters/filters"

  export default {
    name: 'FormFornecedor',
    components: {
      BoxEndereco
    },
    props: {
      propShowModal: { type: Boolean, default: false },
      propFornecedor: { type: Object, default: null}
    },
    data () {
      return {
        localData: {
          cnpj: null,
          ativo: 1,
          telefone: null,
          email: null,
          endereco: {},
          nome: null
        }
      }
    },
    computed: {
      cnpj () {
        let value = this.localData.cnpj || ''

        return filterMaskedNumber(value)
      },
      telefone () {
        let value = this.localData.telefone || ''

        return filterMaskedNumber(value)
      }
    },
    mounted () {
      if (this.propFornecedor) {
        this.localData = {...this.propFornecedor}
      }
    },
    methods: {
      async cadastrarFornecedor () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.$emit('cadastrar', this.localData)
      },
      async editarFornecedor () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.$emit('editar', this.localData)
      },
      getAddress (endereco) {
        this.localData.endereco = endereco
      },
      hide () {
        this.$emit('hide')
      },
      async getFornecedor () {
        try {
          if (!this.localData.cnpj) return

          const cnpj = this.localData.cnpj.replace(/\.|-|\//g, '')
          
          const { name, email, phone, address } = await FornecedorService.getByCNPJ(cnpj)

          const cidade = address.city ? firstCapitalize(address.city).trim() : null

          this.localData = {
            ...this.localData,
            nome: name,
            email: email,
            telefone: phone ? filterTelefone(phone) : null,
            endereco: address ? {
              cep: address.zip,
              logradouro: address.street,
              numero: address.number,
              complemento: address.details,
              bairro: address.neighborhood,
              uf: address.state,
              cidade: cidade ?  cidade.replace(' Da ', ' da ')
                .replace(' De ', ' de ') 
                .replace(' Do ', ' do ') : null,
              ibge: address.city_ibge

            } : {}
          }
        } catch (error) {
          const message = getErrors(error)

          console.error(message.message)

          this.$toast.error('Não foi possível encontrar os dados do beneficiário a partir do CNPJ informado.', {
            position: 'top-right',
            duration: 5000
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  .FormFornecedor {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 5px 10px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_subtitle {
      border-bottom: 1px solid black ;
      margin: 10px 0px;
    }

    &_subtitle h1 {
      font-size: 18px;
      font-weight: 500;
      color: #262626;
    }
  }
</style>

